import { apiPost, apiGet, setAuthToken, setTenantId, getTenantId, unwrap } from './apiClient';
import type { ResponseDTO, AuthenticationRequest, AuthenticationResponse } from '@/types/api';

export async function adminAuthenticate(body: AuthenticationRequest) {
  const res = await apiPost<ResponseDTO<AuthenticationResponse>>(
    '/api/v1/admin/authenticate',
    body
  );
  const data = unwrap(res);
  if (data.token) {
    setAuthToken(data.token);
    // Extract tenantId from JWT payload — try multiple claim names
    try {
      const payload = JSON.parse(atob(data.token.split('.')[1]));
      const tenantId = payload.tenantId || payload.tenant_id || payload.tenant || payload.tid;
      if (tenantId) {
        setTenantId(String(tenantId));
        console.log('[auth] Tenant ID set from JWT:', tenantId);
      } else {
        console.warn('[auth] No tenant ID found in JWT payload. Claims:', Object.keys(payload));
      }
    } catch {
      console.warn('[auth] JWT decode failed — tenant ID won\'t be set');
    }
  }
  // Also check if the response body itself contains tenantId
  if (!getTenantId() && (data as any).tenantId) {
    setTenantId(String((data as any).tenantId));
  }
  return data;
}

export async function deviceAuthenticate(body: Record<string, unknown>) {
  const res = await apiPost<ResponseDTO<unknown>>(
    '/api/v1/device/authenticate',
    body
  );
  return unwrap(res);
}

export async function deviceTermsOfService(body: Record<string, unknown>) {
  const res = await apiPost<ResponseDTO<unknown>>(
    '/api/v1/device/tos',
    body
  );
  return unwrap(res);
}
